// Fallback store for the item currently being dragged, because dataTransfer
// data is not always readable from every drop target in all browsers/contexts.

let draggedItem: ?{ path: string, type: string } = null;

export const setDraggedItem = (path: string, type: string) => {
  draggedItem = { path, type };
};

export const getDraggedItem = () => draggedItem;

export const clearDraggedItem = () => {
  draggedItem = null;
};
